<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [title]="'Semantics Time Series Intent'"
  [chartType]="'bar'"
  [options]="options"
  [translateLabels]="true"
></app-bar-chart>
